import PropTypes from "prop-types";
import React from "react";

import classNames from "classnames";

import "./_style.scss";

const LoadingSpinner = ({ size = 64, label = null }) => (
  <div className="loading-spinner__container">
    <div
      className={
        classNames(
          "loading-spinner",
        )
      }
      style={{
        fontSize: `${size}px`,
      }}
    >
      <div />
      <div />
      <div />
      <div />
    </div>

    {label && (<div>{label}</div>)}
  </div>
);

LoadingSpinner.propTypes = {
  size: PropTypes.number,
};

export default LoadingSpinner;
